import api from './axiosConfig';
import CustomEventDispatcher from './CustomEventDispatcher';

export class FetchInvoicesAction extends CustomEventDispatcher {

    controller = {};
    responsesData = {};
    response = null;

    constructor() {
        super();
        this.response = {};
    }
    
    /**
     * Leegt de cache van opgehaalde facturen om verse data te forceren bij volgende aanvragen
     */
    clearCache() {
        this.responsesData = {};
        this.controller = {};
    }

    async getInvoices(
        page = 1,
        pageSize = 50,
        sortField = 'updated_at',
        sortDirection = 'DESC',
        search = '',
        dataStart = '',
        dataEnd = '',
        status = '',
        customers = '',
        invoiceDateStart = '',
        invoiceDateEnd = '',
        amountMin = null,
        amountMax = null,
    ) {
        let requestKey = '/api/invoices?';
        requestKey += `page=${page}&pageSize=${pageSize}`;
        requestKey += `&sortDirection=${sortDirection}&sortField=${sortField}`;
        requestKey += `&search=${search}&status=${status}`;
        requestKey += `&dataStart=${dataStart}&dataEnd=${dataEnd}`;
        requestKey += `&customers=${customers}`;
        requestKey += `&invoiceDateStart=${invoiceDateStart}&invoiceDateEnd=${invoiceDateEnd}`;
        requestKey += `&amountMin=${amountMin}&amountMax=${amountMax}`;

        if (this.responsesData[requestKey]) {
            return this.responsesData[requestKey];
        }

        if (this.controller[requestKey]) {
            this.controller[requestKey].abort();
        }
        this.controller[requestKey] = new AbortController();

        return this.#fetch(requestKey);
    }

    async #fetch(requestKey) {
        try {
            let config = {
                headers: { 'Content-Type': 'application/json' },
            }
            if (this.controller[requestKey] && this.controller[requestKey].signal) {
                config.signal = this.controller[requestKey].signal;
            }
            const response = await api.get(requestKey, config);

            if (response.status === 401) {
                this._dispatchUnauthorized();
                return [];
            }

            if (response.status !== 200 || !response.data) {
                console.error('Invalid response:', response);
                return [];
            }

            this.responsesData[requestKey] = response.data;

            // Dispatch event for UI updates
            this.#dispatchCustomEventWithDelay('invoicesLoaded', response.data);

            return response.data;
        } catch (error) {
            return this.#handleGetInvoicesError(error);
        }
    }

    #dispatchCustomEventWithDelay(eventName, detail, delay = 100) {
        //small timeout required to let data be incorporated in table
        setTimeout(() => {
            this.dispatchEvent(new CustomEvent(eventName, { detail }));
        }, delay);
    }

    #handleGetInvoicesError(error) {
        if (error.name === 'AbortError' || error.name === 'CanceledError') {
            return [];
        }

        if (error?.response?.status === 401) {
            this._dispatchUnauthorized();
        } else {
            this._dispatchCustomEvent('getInvoicesFailed', error?.response?.data || 'Error in database');
        }

        return [];
    }
}

export default new FetchInvoicesAction();
